import { useNavigate } from 'react-router-dom';
import { revalidateProfile } from './useProfile';
import { client } from '@/graphql/client';
import { logoutMutation } from '@/graphql/mutation';
import posthog from 'posthog-js';

export const useLogout = () => {
  const navigate = useNavigate();
  return async () => {
    try {
      await client.mutate({
        mutation: logoutMutation
      });
      posthog.reset();
    } finally {
      navigate('/');
      revalidateProfile();
    }
  };
};
